import { render, staticRenderFns } from "./registercom.vue?vue&type=template&id=5bf06522&scoped=true&"
import script from "./registercom.vue?vue&type=script&lang=js&"
export * from "./registercom.vue?vue&type=script&lang=js&"
import style0 from "./registercom.vue?vue&type=style&index=0&id=5bf06522&lang=scss&scoped=true&"
import style1 from "./registercom.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf06522",
  null
  
)

export default component.exports